export default __webpack_public_path__ + "static/media/CNo.62-2.bc124863.jpg";